module.exports = __webpack_public_path__ + "img/aew-logo-horizontal.62cc2ed9.png";